import React from 'react';
import '../Style/Contact.css';


import { Box, Container, Grid,Typography} from '@mui/material';
import Registration from './Registration';
import Comunication from './Comunication';
import ComunicationPhone from './ComunicationPhone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CallCenter from '../components1/CallCenter';
import ComunicationEmail from './ComunicationEmail';

function Contact() {
  return (
    <div>
      <Container sx={{scale:'0.55',marginTop:-8}}><CallCenter/></Container>
      <Comunication/>
      <ComunicationPhone/>
      <ComunicationEmail/>
      <Container sx={{marginTop:-22}}>
        <Grid className='informationOne' container spacing={2}>
          <Grid className='satisOfisi' size={6} sx={{width:'50%', padding:2,justifyContent:'center', alignContent:'center'}}>
            <Grid className='satisOfisiWelcome'>
              <Typography variant='h3'>Bilgi almak ve sorularınız için lütfen iletişime geçiniz.</Typography>
            </Grid>
            <Grid>
              <div>
                  <a href="https://api.whatsapp.com/send?phone=905322005989"><Box sx={{width:'70%', height:50, backgroundColor:"rgb(37, 211, 102)",marginTop:5}}>
                          <span><WhatsAppIcon/></span><span><Typography variant='body1'>Whatsup İle İletişime Geçiniz</Typography></span>
                        </Box></a></div>
                <div>
                  <a href="tel:+905322005989"><Box sx={{width:'70%', height:50, backgroundColor:"tomato",marginTop:2,justifyContent:'center', alignContent:'center'}}>
                        <Typography variant='body1'>Telefon Ediniz</Typography>
                      </Box></a></div>
            </Grid>
              
          </Grid>
          <Grid className='contactSize' size={6} sx={{width:'50%', padding:2}}>
            <Registration/>
          </Grid>
        </Grid>
      </Container >
      <Container sx={{padding:2,marginTop:3}}>
        <Grid container spacing={2}>
          <Grid className='satisOfisi' size={6} sx={{width:'50%', padding:2,justifyContent:'center', alignContent:'center'}}>
            <Typography variant='h3'>Satış Ofisi</Typography>
            <br />
            <Typography variant='h6'>Adresimiz</Typography>
            <Typography variant='h6'>Cebeci Mah. 2457 Sok. No:23/B</Typography>
            <Typography variant='h6'>Sultangazi / İstanbul</Typography>
            <br />
            <Typography variant='h6'>Telefon</Typography>
            <Typography variant='h6'>0 532 200 59 89</Typography>
            <br />
            <Typography variant='h6'>E-Mail</Typography>
            <Typography variant='h6'>info@emlakcinn.com</Typography>
          </Grid>
          <Grid className='mapProperties' size={6} sx={{width:'50%', padding:2}}>
            <iframe src="https://www.google.com/maps/d/u/0/embed?mid=1DFDjEoxpoeEHlKAFkgC0d80keJZsExU&ehbc=2E312F&noprof=1" width="100%" height="480"></iframe>
          </Grid>
        </Grid>
        
      </Container>
    </div>
    
  )
}

export default Contact;